import colors from 'styles/colors'
import { typography } from 'styles/typography'

const videoStatusContainer = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderBottomLeftRadius: 2,
  borderBottomRightRadius: 2,
  padding: '2px 0',
  backgroundColor: 'rgba(18,54,104,0.8)'
}

export const defaultStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '20px 0 23px 20px',
    backgroundColor: colors.white
  },
  imageContainer: {
    position: 'relative',
    height: 97,
    width: 71,
    marginRight: 37,
    borderRadius: '2px'
  },
  image: {
    boxSizing: 'border-box',
    border: `1px solid ${colors.unicornSilver}`,
    borderRadius: '2px',
    height: '100%',
    objectFit: 'cover'
  },
  absolutVideoStatusContainer: {
    ...videoStatusContainer,
    position: 'absolute',
    bottom: 0,
    width: '100%'
  },
  relativeVideoStatusContainer: {
    ...videoStatusContainer,
    marginTop: 3,
    marginLeft: 10,
    padding: '2px 5px',
    borderRadius: 3
  },
  videoStatusText: {
    margin: 0,
    ...typography.fontMedium,
    fontSize: 9,
    lineHeight: '10px',
    color: colors.white
  },
  videoCameraIcon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 9,
    margin: '0 0 0 3px',
    color: colors.white
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  name: {
    ...typography.fontBold,
    fontSize: 20,
    letterSpacing: 0.29,
    lineHeight: '22px',
    color: colors.lightBlack
  },
  secondary: {
    marginTop: 4.5,
    marginBottom: 11,
    ...typography.font,
    fontSize: 16,
    letterSpacing: 0.16,
    lineHeight: '15px',
    color: colors.grey
  },
  rating: {
    container: {
      marginBottom: 7
    }
  },
  networkInfoContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  networkInfoIconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 5
  },
  networkInfoText: {
    ...typography.font,
    color: colors.lightGray,
    fontSize: 14,
    lineHeight: '12px'
  }
}
